import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  sharedQuestion2026,
  sharedTipHintA12026,
  sharedTipHintDisabilityPension2026,
  sharedTipHintEarlyRetirement2026,
  sharedTipHintInsolvention2026,
  sharedTipHintOtherPension2026,
  sharedTipHintNoresident2026,
  sharedTipHintConsultation2026,
  sharedTipHintNoresidentTaxDomicile2026,
  sharedTipHintResident2026,
  sharedTipHintRetirement2026,
  sharedTipHintZTPP2026,
  sharedTipHintZZ2026
} from './complete-form';
import moment from 'moment';
import { translate } from '@ngneat/transloco';
import { AbstractControl } from '@angular/forms';

/// novy zaklad
export const employeeFormPersonInfo2026 = (
  personalData: boolean,
  editable: boolean
): FormlyFieldConfig[] => [
    {
      key: 'personalPart',
      props: {},
      // expressionProperties: {
      //   className: () => (personalData ? 'p-col-12' : 'none'),
      //   'props.disabled': () => !editable,
      // },
      expressionProperties: {
        'props:disabled': 'formState.disablePersonalPart',
      },
      fieldGroup: [
        {
          type: 'h2',
          props: {
            prefix: '1. ',
            label: 'TPA.BasicInfo',
          },
        },
        {
          type: 'personal-info-2026',
          key: 'personalInfo',
          className: 'p-col-12',
          props: {
            translate: true,
            label: 'TPA.BasicInfo',
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
          },
        },

        {
          type: 'h2',
          props: {
            prefix: '2. ',
            label: 'TPA.Addresses',
          },
        },
        {
          type: 'address',
          key: 'permanentniAdresa',
          props: {
            translate: true,
            label: 'TPA.PermanentAddress',
            description: 'TPA.DocumentAccordance',
            hintKind: 'address',
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
          },
        },
        {
          type: 'address',
          key: 'kontaktniAdresa',
          props: {
            translate: true,
            label: 'TPA.ContactAddress',
            actionPathKey: 'permanentniAdresa',
            actionText: 'TPA.SetUpSameAsPermanentniAdresa',
            anotherAddress: 'TPA.SetUpSameAsPermanentniAdresa',
            hintKind: 'address',
          },

          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
            'props.sameAsAnotherAddress': (model, formState, field) => {
              const a = JSON.stringify(
                field?.parent?.fieldGroup?.find(
                  (p) => p.key == 'permanentniAdresa'
                )?.model
              );
              const m = JSON.stringify(model);
              return a == m;
            },

          },
        },
        sharedQuestion2026({
          key: 'mamCeskouPrechodnouAdresu',
          className: "pl-[10px] block p-col-12",
          props: {
            label: 'TPA.Guide.Step3DoYouHaveCheckAddress',
            translate: true,
            labelClass: 'h4',
          },
          // Hide the question entirely when the personal part is locked —
          // the user can't change it anyway and showing a readonly Yes/No
          // adds noise to the review step.
          hideExpression: (model, formState, field) =>
            !!formState?.disablePersonalPart ||
            field?.parent?.model?.personalInfo?.statniPrislusnost == 'CZ'
        }),
        {
          type: 'address',
          key: 'prechodnaAdresa',
          props: {
            translate: true,
            label: 'TPA.TemporaryAddress',
            actionPathKey: 'kontaktniAdresa',
            actionText: 'TPA.SetUpSameAsContactAddress',
            anotherAddress: 'TPA.SetUpSameAsContactAddress',
            hintKind: 'address',
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
            'props.disabled': 'formState.disablePersonalPart',
            'props.sameAsAnotherAddress': (model, formState, field) => {
              const a = JSON.stringify(
                field?.parent?.fieldGroup?.find((p) => p.key == 'kontaktniAdresa')
                  ?.model
              );
              const m = JSON.stringify(model);
              return a == m;
            },
          },
          validators: {
            validation: [
              {
                name: 'validateCzechRepublicAddress',
                options: { errorPath: 'zeme' },
              },
            ],
          },
          hideExpression: (m, formState, field) => {
            return !field?.parent?.model?.mamCeskouPrechodnouAdresu || field?.parent?.model?.personalInfo?.statniPrislusnost == 'CZ';
          },
        },
        {
          type: 'h2',
          props: {
            prefix: '3. ',
            label: 'TPA.AdditionalInfo',
          },
        },
        {
          type: 'wage',
          key: 'wage',
          props: {
            translate: true,
            label: 'TPA.Salary',
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
          },
        },
        {
          type: 'health-2026',
          key: 'health',
          props: {
            translate: true,
            label: 'TPA.HealthInsuranceAndState',
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
          },

          validators: {
            validation: [
              {
                name: 'dateRangeValidationError',
                options: { errorPath: 'priznaneDo' },
              },
            ],
          },

        },
        sharedTipHintA12026(),
        sharedTipHintZTPP2026(),
        sharedTipHintZZ2026(),
        sharedTipHintDisabilityPension2026(),
        sharedTipHintEarlyRetirement2026(),
        sharedTipHintRetirement2026(),
        sharedTipHintOtherPension2026(),

        {
          type: 'idcard-2026',
          key: 'idcard',
          props: {
            translate: true,
            label: 'TPA.IdentificationCard',
          },
          hideExpression: (m, formState, field) => {
            return field?.parent?.model?.personalInfo.statniPrislusnost == 'CZ';
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
          },
        },

        {
          type: 'anotherCompany',
          key: 'dalsiPracovniPomer',
          props: {
            translate: true,
            label: 'TPA.OtherEmployers',
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
          },
        },
        {
          type: 'executions-2026',
          key: 'execution',
          props: {
            translate: true,
            label: 'TPA.Execution',
          },
          expressionProperties: {
            'props.readonly': 'formState.disablePersonalPart',
          },
        },
        sharedTipHintInsolvention2026(),


        // Tax(),
        // {
        //   template: `<h2 class="h2-form">4.
        //       ${translate('TPA.AdditionalInfo')}
        //       </h2>`,
        // },
        // BankAccount(),
        // Health(),
        // Certificate(),
      ],
    },
    {
      hideExpression: '!formState.hideTaxDeclarationPart',
      key: 'taxDeclaration',
      className: 'p-col-12',
      fieldGroup: [
        {
          type: 'rezidentura-2026',
          key: 'rezidentura',
          props: {
            translate: true,
            label: 'TPA.ResidentureRecognition',
          },
        },

        sharedTipHintResident2026(),
        sharedTipHintNoresident2026(),
        sharedTipHintConsultation2026(),
        sharedTipHintNoresidentTaxDomicile2026(),
      ]
    }
  ];
